import * as tslib_1 from "tslib";
var SirenCache = /** @class */ (function () {
    function SirenCache() {
        this._cache = new Map();
        this._actions = new Map();
        this._links = new Map();
        this._isRestoring = false;
    }
    SirenCache.prototype.getResponse = function (key) {
        return this._cache.get(key);
    };
    SirenCache.prototype.setResponse = function (key, value) {
        var _this = this;
        try {
            this._cache.set(key, value);
            if (value.actions != null && value.actions.length > 0) {
                value.actions.forEach(function (item) {
                    _this._actions.set(item.name, item);
                });
            }
            if (value.links != null && value.links.length > 0) {
                value.links.forEach(function (item) {
                    _this._links.set(item.rel[0], item);
                });
            }
        }
        catch (err) {
            console.error('Error saving response', err);
        }
    };
    SirenCache.prototype.restore = function (responses) {
        var e_1, _a;
        try {
            this._isRestoring = true;
            try {
                for (var _b = tslib_1.__values(Object.keys(responses)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    this.setResponse(key, responses[key]);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        finally {
            this._isRestoring = false;
        }
    };
    SirenCache.prototype.getAction = function (name) {
        return this._actions.get(name);
    };
    SirenCache.prototype.getLink = function (name) {
        return this._links.get(name);
    };
    return SirenCache;
}());
export { SirenCache };
